import { connect } from 'react-redux';
import type { Dispatch } from 'redux';

import { config } from '../../config';
import { type DisplayMessages, getDisplayMessages, getLocale } from '../../configuration/lang/langSlice';
import { isUserSessionExpired } from '../../configuration/login/loginSlice';
import { getIdToken } from '../../configuration/tokenHandling/tokenSlice';
import type { State } from '../../reducers';
import { getSessionExpiredAcknowledged } from '../reducers/selectors';
import App from './App';
import { hideSessionExpiredDialog } from './App.actions';

export interface AppPropertiesFromDispatch {
    hideSessionDialog: () => void;
}

export interface AppPropertiesFromState {
    idToken: string | null;
    homeRoute: string;
    displayMessages: DisplayMessages | undefined;
    showSessionExpired: boolean;
    userLocale: string | undefined;
}

const mapDispatchToProps = (dispatch: Dispatch): AppPropertiesFromDispatch => ({
    hideSessionDialog: () => dispatch(hideSessionExpiredDialog()),
});

const mapStateToProps = (state: State): AppPropertiesFromState => ({
    idToken: getIdToken(state),
    homeRoute: config.homeRoute as string,
    displayMessages: getDisplayMessages(state),
    showSessionExpired: isUserSessionExpired(state) && !getSessionExpiredAcknowledged(state),
    userLocale: getLocale(state),
});

const AppContainer = connect(mapStateToProps, mapDispatchToProps)(App);

export default AppContainer;
